import type { FaireProductEntity } from "../../entity_types/product";

export const p_57qh73ptq3: FaireProductEntity = {
  token: "p_57qh73ptq3",
  type: "product",
  name: "Hexagonal Cone Pendulum Pendant",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Gemcohub",
  imageUrl:
    "https://cdn.faire.com/fastly/685bfd5e2ee62d4355515c687edf939bf8cfddebae68dc48dd728d9e0eb4dfa6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ca24060979ce493271c7e438171db7fb6100a0581484c1bc0edd3ce580fa830.jpeg",
    "https://cdn.faire.com/fastly/8d735db4ada2ba9dc3ca29d1f3278b59c4b5079daa69d2c7e55916dbeebe53c2.jpeg",
    "https://cdn.faire.com/fastly/03bd04485a9c72a4e86e3743761d36684dfc90df7e75237cd14e22d959194879.jpeg",
    "https://cdn.faire.com/fastly/da662974dd1a4e630d56dd71bcfb0b52038de7e1a6a50fb665489fb92abc2ee0.jpeg",
  ],
  priceDollars: 8.32,
  description:
    "Application: this pendulum is perfect for divination, chakra testing and spiritual healing, tantrism, spiritualism and eradication of evil forces.\nDowsing pendulum: made of copper material, conical pointed cone dowsing pendulum.\n\nDurable: compared with the crystal pendulum, copper pendulum is more durable and won't broken.\n\n-ID: GEM-KS-P2422\n-Material: Copper\n-Height: 40mm\n-Width: 17mm\n-Weight(s): 26g\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:35.621Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
